// External deps

import { Col, Row } from 'react-bootstrap';
import { ContentCard, Label } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

// Internal deps
import DatesColumn from '../TemporalComponents/DatesColumn/DatesColumn';
import { formatDate } from '../../../utils/formatUtils';
import './NotificationReportHeader.scss';

const NotificationReportHeader = ({ data }) => {
  const datesList = [
    {
      label: 'Fecha desde',
      value: formatDate({ value: data.fechaDesde })
    },
    {
      label: 'Fecha hasta',
      value: formatDate({ value: data.fechaHasta })
    }
  ];

  return (
    <>
      <ContentCard className="mb-5" mark="none" orientation="vertical">
        <Row>
          <Col className="d-flex flex-column justify-content-between" sm={3}>
            <Label label="Pozo" value={data.pozo} />
            <Label label="Contratista" value={data.contratista} />
          </Col>
          <Col className="d-flex flex-column justify-content-between" sm={3}>
            <Label label="Evento" value={data.evento} />
            <Label label="Moneda" value={data.moneda} />
          </Col>
          <Col className="d-flex flex-column justify-content-between" sm={3}>
            <Label label="Equipo" value={data.equipo} />
            <Label label="Contrato" value={data.contrato} />
          </Col>
          <Col className="d-flex flex-column justify-content-between" sm={3}>
            <DatesColumn datesList={datesList} />
          </Col>
        </Row>
      </ContentCard>
    </>
  );
};

NotificationReportHeader.propTypes = {
  data: PropTypes.shape({
    contratista: PropTypes.string,
    contrato: PropTypes.number,
    equipo: PropTypes.string,
    evento: PropTypes.string,
    fechaDesde: PropTypes.string,
    fechaHasta: PropTypes.string,
    moneda: PropTypes.string,
    pozo: PropTypes.string
  })
};
NotificationReportHeader.defaultProps = {
  data: {}
};

export default NotificationReportHeader;
